import { DESCRIPTOR } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(DESCRIPTOR);
const actions = { ...rawActions, ...thunkFactory(DESCRIPTOR, '/descritor/') };
export { actions };

// REDUCER
const initialState = {
  data: [],
  dataById: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

export default reducerFactory(DESCRIPTOR, initialState);

// SAGAS
const sagas = sagasFactory(DESCRIPTOR, '/descritor/');
export { sagas };
